import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asHeaderEdit" }
const _hoisted_2 = {
  class: "asHeaderEdit_title",
  "data-cy": "headerEditTitle"
}
const _hoisted_3 = { class: "asHeaderEdit_menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "asHeaderEdit_back",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: '/user/setting',
        class: "asHeaderEdit_setting"
      })
    ])
  ]))
}